import { Performer } from '../core/performer'
import { HttpMethod } from '../core/types'

export class UploadPhotos extends Performer<
  {
    urlParams: {
      id: string
    }
    payload: FormData
  },
  void
> {
  protected method = HttpMethod.POST
  protected url = '/chatters/{id}/upload-photos'
}

export default new UploadPhotos().perform
